// extracted by mini-css-extract-plugin
export default {"input":"List_input__IYHH5","generateButton":"List_generateButton__LH5na","printButton":"List_printButton__QVBy6","qrContainer":"List_qrContainer__n3Mnl"};